var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticClass:"dashboard-bar-chart",attrs:{"bordered":false}},[_c('chart-pies',{attrs:{"height":210,"data":_vm.barChartData}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }